module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/51b6bffe553abf33ea1939808f41ba05.gif";